import { API_BASE_URL } from "../../../Services/baseApiUrl";

const RFID_IMAGE_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, "/RFIDImages/");

export const resolveRfidImageUrl = (url) => {
  if (!url) return "";
  const trimmed = String(url).trim();
  // if (!trimmed) return "";
  if (!trimmed || trimmed.toLowerCase() === "n/a") return "";

  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    return trimmed;
  }

  const normalized = trimmed.replace(/\\/g, "/");
  const filename = normalized.split("/").filter(Boolean).pop() || "";

  if (/^[A-Za-z]:/.test(normalized) && filename) {
    return `${RFID_IMAGE_BASE_URL}${filename}`;
  }

  if (normalized.toLowerCase().startsWith("rfidimages/")) {
    const siteBase = API_BASE_URL.replace(/\/api\/?$/, "/");
    return `${siteBase}${normalized.replace(/^\//, "")}`;
  }

  return `${RFID_IMAGE_BASE_URL}${normalized.replace(/^\//, "")}`;
};

const isImageBlob = (blob, resolvedUrl) => {
  if (blob.type.startsWith("image/")) return true;
  if (blob.type && !["application/octet-stream", ""].includes(blob.type)) {
    return false;
  }
  return /\.(jpe?g|png|webp|gif|bmp)$/i.test(resolvedUrl);
};

export const fetchRfidImageBlobUrl = async (url) => {
  const resolved = resolveRfidImageUrl(url);
  if (!resolved) return null;

  try {
    const token = localStorage.getItem("token");
    const response = await fetch(resolved, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    if (!response.ok) return null;

    const blob = await response.blob();
    if (!isImageBlob(blob, resolved)) return null;

    return URL.createObjectURL(blob);
  } catch {
    return null;
  }
};
